import { Component } from '@angular/core';

@Component({
  selector: '[app-tr-client]',
  template: `
    <p>
      tr-client works!
    </p>
  `,
  styles: ``
})
export class TrClientComponent {

}
